var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('contract-form',{attrs:{"loading":_vm.loading,"contractData":_vm.contract,"formErrors":_vm.formErrors},on:{"contractSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }